<!-- Upcoming invoicing preview -->
<elcia-card>
  <div class="flex flex-col gap-4">
    <div class="flex items-center gap-2">
      <span class="text-lg font-bold">{{ 'customer-billing.upcoming' | translate }}</span>
      <span class="text-xs bg-[var(--p-surface-200)] rounded-full py-0.5 px-2">{{ previewLines().length }}</span>
    </div>

    @if (previewLines().length === 0) {
      <div class="flex justify-center py-8 text-surface-400">
        {{ 'customer-billing.nothing-to-invoice' | translate }}
      </div>
    } @else {
      <div class="flex flex-col gap-2">
        @for (line of previewLines(); track $index) {
          <div class="flex items-center gap-4 p-4 rounded-xl border border-primary-50">
            <!-- Label + badges -->
            <div class="flex flex-1 min-w-0 flex-col gap-0.5">
              <div class="flex items-center gap-2 flex-wrap">
                <span class="font-semibold">{{ line.label }}</span>
                @if (line.isTimesheet) {
                  <span class="text-xs bg-[var(--p-surface-200)] text-surface-500 rounded-full py-0.5 px-2">
                    {{ 'customer-billing.timesheets' | translate }}
                  </span>
                }
              </div>
              @if (line.description) {
                <span [title]="line.description" class="text-sm text-surface-400 truncate">{{ line.description }}</span>
              }
            </div>
            <!-- Qty × unit price -->
            <span class="text-sm text-surface-400 whitespace-nowrap tabular-nums">
              {{ line.quantity | number:'1.0-2' }} &times; {{ line.unitPrice | number:'1.2-2' }} €
            </span>
            <!-- Line amount -->
            <span class="font-semibold whitespace-nowrap w-28 text-right tabular-nums">
              {{ line.amount | number:'1.2-2' }} €
            </span>
          </div>
        }
        <!-- Total row -->
        <div class="flex items-center justify-end gap-4 px-4 pt-2 border-t border-primary-50">
          <span class="text-sm text-surface-400">{{ 'customer-billing.total' | translate }}</span>
          <span class="font-bold whitespace-nowrap w-28 text-right tabular-nums">
            {{ previewTotal() | number:'1.2-2' }} €
          </span>
        </div>
      </div>
    }
  </div>
</elcia-card>

<!-- Billing history -->
<elcia-card>
  <div class="flex flex-col gap-4">
    <div class="flex items-center gap-2">
      <span class="text-lg font-bold">{{ 'customer-billing.history' | translate }}</span>
      <span class="text-xs bg-[var(--p-surface-200)] rounded-full py-0.5 px-2">{{ billings().length }}</span>
    </div>

    @if (billings().length === 0) {
      <div class="flex justify-center py-8 text-surface-400">
        {{ 'customer-billing.no-history' | translate }}
      </div>
    } @else {
      <div class="flex flex-col gap-2">
        @for (billing of billings(); track billing.id) {
          <div (click)="openInvoice(billing)"
               class="flex items-center gap-4 p-4 rounded-xl border border-primary-50 cursor-pointer transition-colors hover:bg-primary-50">
            <!-- Product name + period -->
            <div class="flex flex-1 min-w-0 flex-col gap-0.5">
              <span class="font-semibold truncate">{{ productName(billing) }}</span>
              <div class="flex items-center gap-1.5 text-sm text-surface-400">
                @if (isOneShot(billing)) {
                  <!-- One-shot: single date + badge -->
                  <span class="whitespace-nowrap tabular-nums">{{ billing.periodStart | date:'dd/MM/yyyy' }}</span>
                  <span
                    class="text-xs bg-[var(--p-surface-200)] text-surface-500 rounded-full py-0.5 px-2 leading-none">
                    {{ 'customer-billing.one-shot' | translate }}
                  </span>
                } @else {
                  <!-- Recurring: date range -->
                  <span class="whitespace-nowrap tabular-nums">{{ billing.periodStart | date:'dd/MM/yyyy' }}</span>
                  <span class="text-surface-300">&rarr;</span>
                  <span class="whitespace-nowrap tabular-nums">{{ billing.periodEnd | date:'dd/MM/yyyy' }}</span>
                }
              </div>
            </div>
            <!-- Invoice number + state badge -->
            <div class="flex items-center gap-2 whitespace-nowrap shrink-0">
              @if (billing.invoiceNumber) {
                <span class="text-sm text-surface-400">{{ billing.invoiceNumber }}</span>
              }
              <elcia-billing-badge [state]="billing.invoiceState"/>
            </div>
            <!-- Amount -->
            <span class="font-semibold whitespace-nowrap w-28 text-right tabular-nums shrink-0">
              {{ billing.amount | number:'1.2-2' }} €
            </span>
          </div>
        }
      </div>
    }
  </div>
</elcia-card>
